/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Amendment_Link_MissingInputs */

const en_orders_amendment_link_missing = /** @type {(inputs: Orders_Amendment_Link_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing Link`)
};

const es_orders_amendment_link_missing = /** @type {(inputs: Orders_Amendment_Link_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falta link`)
};

/**
* | output |
* | --- |
* | "Missing Link" |
*
* @param {Orders_Amendment_Link_MissingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_amendment_link_missing = /** @type {((inputs?: Orders_Amendment_Link_MissingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Amendment_Link_MissingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_amendment_link_missing(inputs)
	return es_orders_amendment_link_missing(inputs)
});